import moment from "moment"

export const db_format = "YYYY-MM-DD HH:mm:ss"
export function localToUtc(date_string, format = db_format) {
    if (!date_string) return null
    return moment(date_string).utc().format(format)
}
export function utcToLocal(date_string, format = db_format) {
    if (!date_string) return ""
    return moment.utc(date_string).local().format(format)
}
